import { FilmWishlistBasicsFragment } from "@generated-types"
import { tv } from "@utils/tw"
import { IconWishlistAnimated } from "./IconWishlistAnimated"
import { useWishlistEnabled, useWishlistToggle } from "./useWishlist"
import { getMixpanelPayload, trackEvent } from "@features/tracking/tracking"
import { trackFilmInterest } from "@features/tracking/film-history"
import { useFerveMode } from "@features/ferve/useFerveMode"

type Props = {
  film: string | number | FilmWishlistBasicsFragment
}

export function WishlistIcon(props: Props) {
  const enabled = useWishlistEnabled()
  const state = useWishlistToggle(props.film)
  const styles = createStyles()
  const mode = useFerveMode()

  if (!enabled || !state) return null

  return (
    <button
      className={styles}
      onClick={(e) => {
        e.preventDefault()
        state.toggle()
        trackEvent("Add to Wishlist", {}, e.currentTarget)
        if (!state.active) {
          trackFilmInterest(getMixpanelPayload(e.currentTarget).FilmUri, "trailer")
        }
      }}
    >
      <IconWishlistAnimated active={state.active} />
    </button>
  )
}

const createStyles = tv({
  base: ["bg-transparent size-icon inline-flex items-center justify-center cursor-pointer"],
})
